var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddpeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3489_109032)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3.00049C10.9391 3.00049 9.92172 3.42192 9.17157 4.17206C8.42143 4.92221 8 5.93962 8 7.00049C8 8.06135 8.42143 9.07877 9.17157 9.82892C9.92172 10.5791 10.9391 11.0005 12 11.0005C13.0609 11.0005 14.0783 10.5791 14.8284 9.82892C15.5786 9.07877 16 8.06135 16 7.00049C16 5.93962 15.5786 4.92221 14.8284 4.17206C14.0783 3.42192 13.0609 3.00049 12 3.00049ZM18 12.0005C14.7 12.0005 12 14.7005 12 18.0005C12 21.3005 14.7 24.0005 18 24.0005C21.3 24.0005 24 21.3005 24 18.0005C24 14.7005 21.3 12.0005 18 12.0005ZM11.0508 14.0474C7.89078 14.3094 3 15.7965 3 18.5005V21.0005H10.5879C10.2119 20.0735 10 19.0625 10 18.0005C10 16.5605 10.3848 15.2144 11.0508 14.0474ZM18 15.0005C18.552 15.0005 19 15.4485 19 16.0005V17.0005H20C20.552 17.0005 21 17.4485 21 18.0005C21 18.5525 20.552 19.0005 20 19.0005H19V20.0005C19 20.5525 18.552 21.0005 18 21.0005C17.448 21.0005 17 20.5525 17 20.0005V19.0005H16C15.448 19.0005 15 18.5525 15 18.0005C15 17.4485 15.448 17.0005 16 17.0005H17V16.0005C17 15.4485 17.448 15.0005 18 15.0005Z",
    fill: "currentcolor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3489_109032"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.000488281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddpeople);
export default __webpack_public_path__ + "static/media/Add people.f1cffca6f608dc75f28500dfb3f2fb1c.svg";
export { ForwardRef as ReactComponent };